import CmsApi from '@/api/cms';
import {ref} from 'vue';

export async function useCmsPage(pageId, userParams, params) {
  const pageData = ref({});
  const isLoading = ref(false);

  try {
    isLoading.value = true;
    const data = await CmsApi.getPageById(userParams, pageId, params);
    pageData.value = data;
  } catch (error) {
    console.error(`Failed to fetch cms data for page: ${pageId}`, error);
  } finally {
    isLoading.value = false;
  }

  return {pageData, isLoading};
}
